import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=681b6fce&"
import script from "./checkout.vue?vue&type=script&lang=ts&"
export * from "./checkout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeaderBasic: require('/home/vsts/work/1/a/NuxtApp/components/app/header/Basic.vue').default,AppLazyHydrate: require('/home/vsts/work/1/a/NuxtApp/components/app/LazyHydrate.vue').default,AppFooter: require('/home/vsts/work/1/a/NuxtApp/components/app/footer/index.vue').default,AppLayout: require('/home/vsts/work/1/a/NuxtApp/components/app/Layout.vue').default})
